import type * as React from "react";

import { cn } from "@/lib/utils";

export function PageHeader({
	title,
	description,
	actions,
	className,
}: {
	title: React.ReactNode;
	description?: React.ReactNode;
	actions?: React.ReactNode;
	className?: string;
}) {
	return (
		<header
			className={cn(
				"flex flex-wrap items-end justify-between gap-4",
				className,
			)}
		>
			<div className="flex min-w-0 flex-col gap-1.5">
				<h1 className="type-display" data-testid="page-title">
					{title}
				</h1>
				{description && (
					<p className="text-muted-foreground" data-testid="page-description">
						{description}
					</p>
				)}
			</div>
			{actions && <div className="flex items-center gap-2">{actions}</div>}
		</header>
	);
}

export function SectionLabel({
	children,
	className,
}: {
	children: React.ReactNode;
	className?: string;
}) {
	return (
		<h2
			className={cn(
				"type-eyebrow flex items-center gap-3 after:h-px after:flex-1 after:bg-border",
				className,
			)}
		>
			{children}
		</h2>
	);
}
